import React, { useState } from "react";
import { Outlet, useRoutes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "../auth/SSO/Login";
import HomePage from "../pages/HomePage";
import DashboardPage from "../pages/DashboardPage";
import ClientPage from "../pages/Clientpage";
import EngagementPage from "../pages/Enagementpage";
import WorkflowPage from "../pages/Workflowpage";
import EachWorkflowPage from "../pages/EachWorkflowPage";
import DomainPage from "../pages/DomainPage";
import LogPage from "../pages/LogPage";
import AdminPrivateRoute from "./AdminPrivateRoute";
import AdminPage from "../pages/AdminPage";
import InstrumentPage from "../pages/InstrumentPage";
import EachInstrumentPage from "../pages/EachInstrumentPage";
import LogStreamPage from "../pages/LogStreamPage";
import Header from "../components/Header";

const Routes = () => {
  // State to manage the drawer's open/close status
  const [openDrawer, setOpenDrawer] = useState(true);

  // Function to toggle the drawer's open/close status
  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  return useRoutes([
    {
      // Public route for login page
      path: "/",
      element: <Login />,
    },
    {
      // Protected routes under /dep path
      path: "/dep",
      element: <PrivateRoute />, // Ensures user is authenticated
      children: [
        {
          path: "",
          element: (
            <>
              <Header toggleDrawer={toggleDrawer} />{" "}
              {/* Header component with drawer toggle */}
              <Outlet /> {/* Placeholder for nested routes */}
            </>
          ),
          children: [
            {
              path: "/dep/home",
              element: <HomePage openDrawer={openDrawer} />, // Home page route
            },
            {
              path: "/dep/dashboard",
              element: <DashboardPage openDrawer={openDrawer} />, // Dashboard page route
            },
            {
              path: "/dep/domain",
              element: <DomainPage openDrawer={openDrawer} />, // Domain page route
            },
            {
              path: "/dep/client/:domainId",
              element: <ClientPage openDrawer={openDrawer} />, // Client page route with dynamic domainId
            },
            {
              path: "/dep/engagement/:clientId",
              element: <EngagementPage openDrawer={openDrawer} />, // Engagement page route with dynamic clientId
            },
            {
              path: "/dep/workflow/:engagementId",
              element: <Outlet />, // Placeholder for nested workflow routes
              children: [
                {
                  path: "/dep/workflow/:engagementId/:processType",
                  element: <WorkflowPage openDrawer={openDrawer} />, // Workflow page route with dynamic engagementId and processType
                },
                {
                  path: "/dep/workflow/:engagementId/:processType/onboarding/:workflowName",
                  element: <EachWorkflowPage openDrawer={openDrawer} />, // Each workflow page route with dynamic parameters
                },
                {
                  path: "/dep/workflow/:engagementId/:processType/logs/:workflowType",
                  element: <LogPage openDrawer={openDrawer} />, // Log page route with dynamic parameters
                },
                {
                  path: "/dep/workflow/:engagementId/:processType/logs/:workflowType/:log_stream_name",
                  element: <LogStreamPage openDrawer={openDrawer} />, // Log stream page route with dynamic parameters
                },
              ],
            },
            {
              path: "/dep/instrument",
              element: <Outlet />, // Placeholder for nested instrument routes
              children: [
                {
                  path: "/dep/instrument",
                  element: <InstrumentPage openDrawer={openDrawer} />, // Instrument page route
                },
                {
                  path: "/dep/instrument/:instrumentId/:instrumentName",
                  element: <EachInstrumentPage openDrawer={openDrawer} />, // Each instrument page route with dynamic parameters
                },
              ],
            },
            {
              path: "/dep/admin",
              element: <AdminPrivateRoute />, // Ensures user has admin privileges
              children: [
                {
                  path: "",
                  element: <AdminPage openDrawer={openDrawer} />, // Admin page route
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Fallback route for any unmatched paths
      path: "*",
      element: <h1>Page Not Found</h1>,
    },
  ]);
};

export default Routes;
